import { PageLayout } from '~/components/PageLayout/PageLayout';
import { JudgeLicenseSerializerDetailedGet } from '~/apis/ssf';
import { Table } from '~/components/Table/Table';
import { Fragment } from 'react/jsx-runtime';

function Row({ license }: { license: JudgeLicenseSerializerDetailedGet }) {
  return (
    <Table.Row>
      <Table.Col>{new Date(license.start_date).getFullYear()}</Table.Col>
      <Table.Col>{license.duty_summary?.primary}</Table.Col>
      <Table.Col>{license.duty_summary?.secondary}</Table.Col>
      <Table.Col>{license.duty_summary?.SL}</Table.Col>
      <Table.Col>{license.duty_summary?.BP}</Table.Col>
      <Table.Col>{license.duty_summary?.HD}</Table.Col>
      <Table.Col>{license.duty_summary?.SD}</Table.Col>
      <Table.Col>{license.duty_summary?.TL}</Table.Col>
      <Table.Col>{license.duty_summary?.JU}</Table.Col>
      <Table.Col>{license.duty_summary?.TK}</Table.Col>
      <Table.Col>{license.duty_summary?.SP}</Table.Col>
    </Table.Row>
  );
}

export function RefereeLicensesListTable({
  data,
  isLoading,
}: {
  data: JudgeLicenseSerializerDetailedGet[];
  isLoading: boolean;
}) {
  return (
    <Fragment>
      <PageLayout.SubHeading>Tidigare uppdrag</PageLayout.SubHeading>
      <Table bg="even">
        <Table.Head>
          <Table.Row>
            <Table.Col as="th">År</Table.Col>
            <Table.Col as="th">Primära</Table.Col>
            <Table.Col as="th">Sekundära</Table.Col>
            <Table.Col as="th">SL</Table.Col>
            <Table.Col as="th">BP</Table.Col>
            <Table.Col as="th">HD</Table.Col>
            <Table.Col as="th">SD</Table.Col>
            <Table.Col as="th">TL</Table.Col>
            <Table.Col as="th">JU</Table.Col>
            <Table.Col as="th">TK</Table.Col>
            <Table.Col as="th">SP</Table.Col>
          </Table.Row>
        </Table.Head>
        <Table.Body>
          {isLoading ? <Table.Loading cols={11} /> : data.map(license => <Row license={license} key={license.id} />)}
        </Table.Body>
      </Table>
    </Fragment>
  );
}
